import { useEffect, useState } from "react";
import {
  Button,
  CardHeader,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  List,
  ListItemButton,
  TextField,
} from "../../../../../components";
import palette from "../../../../../styles/dark-theme/palette";

const HistoricoAtivosDialog = ({
  open,
  setOpen,
  cliente,
  ordemServicos,
  ordemServicoEntity,
  setOrdemServico,
}) => {
  const [ativos, setAtivos] = useState([]);
  const [ativoSelecionado, setAtivoSelecionado] = useState(null);
  const [expandedCard, setExpandedCard] = useState({});

  useEffect(() => {
    const ativosDaEntidade = ordemServicoEntity?.ativos || [];
    const camposChave = ativosDaEntidade.map((item) => ({
      ...item.camposPersonalizados?.find((item) => item.campoChave),
      ativoId: item.ativoId,
    }));
    let ativosTemp = [];
    ordemServicos.forEach((item) => {
      if (item.ativos?.length) {
        item.ativos.forEach((ativo) => {
          const ativoExistente = ativosDaEntidade.find(
            ({ ativoId }) => ativo.ativoId === ativoId,
          );
          if (ativoExistente) {
            const campoChave = camposChave.find(
              ({ ativoId }) => ativoId === ativo.ativoId,
            );
            const campoValor = ativo.valoresCampos?.find(
              ({ campoPersonalizadoId }) =>
                campoPersonalizadoId === campoChave.id,
            );
            const valorExistente = ativosTemp.find(ativo => 
              ativo.campos?.find(
                ({ valor, campoPersonalizadoId }) =>
                  valor === campoValor?.valor &&
                  campoPersonalizadoId === campoValor?.campoPersonalizadoId,
              ));
            if (!valorExistente) {
              const campos = ativo.valoresCampos?.map((campo) => {
                const campoExistente = ativoExistente.camposPersonalizados.find(
                  ({ id }) => campo.campoPersonalizadoId === id,
                );
                return {
                  campoPersonalizadoId: campoExistente?.id,
                  label: campoExistente?.label,
                  valor: campo.valor,
                };
              });
              const ativoTemp = {
                id: ativo.id,
                ativoId: ativo.ativoId,
                campos,
              };
              ativosTemp = [...ativosTemp, ativoTemp];
            }
          }
        });
      }
    });
    setAtivos(ativosTemp);
  }, [open]);

  const handleAdicionarAtivo = () => {
    const ativoId = ativoSelecionado.ativoId;
    ativoSelecionado.campos.forEach((item) =>
      ordemServicoEntity.atualizarValorCampoAtivo(
        ativoId,
        item.campoPersonalizadoId,
        item.valor,
      ),
    );
    setOrdemServico({ ...ordemServicoEntity });
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleExpandClick = (item, index) => {
    const expanded =
      index === expandedCard.index ? !expandedCard.expanded : true;
    setExpandedCard({ index, expanded });

    const ativo = expanded ? item : null;
    setAtivoSelecionado(ativo);
  };

  const renderAtivosContent = (ativo, start, end) => {
    const content = [],
      campos = ativo.campos;
    for (let i = start; i < end; i++) {
      content.push(<h6 key={i}>{`${campos[i].label}: ${campos[i].valor}`}</h6>);
    }
    return content;
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <div className="px-3">
        <CardHeader
          title="Lista de Ativos"
          action={
            <IconButton
              color="inherit"
              onClick={handleClose}
              sx={{
                backgroundColor: "#EDEEF0",
                "&:hover": { backgroundColor: "#B6BABC" },
              }}
            >
              <i
                className="ph-bold ph-x"
                style={{ fontSize: "clamp(17px, 4vw, 20px)" }}
              ></i>
            </IconButton>
          }
        />
      </div>
      <DialogContent sx={{ p: 0, pb: 1, px: 3 }}>
        <TextField
          id="clienteSelecionado"
          name="clienteSelecionado"
          label="Cliente"
          variant="outlined"
          margin="normal"
          value={cliente?.nomeRazaoSocial}
          disabled
        />
        <List sx={{ maxHeight: 420, overflowY: "auto", pr: 1, mt: 1 }}>
          {ativos?.map((ativo, index) => (
            <ListItemButton
              key={index}
              sx={{
                borderRadius: "8px",
                mb: 2,
                py: 2,
                px: 2,
                border:
                  ativoSelecionado?.id === ativo.id
                    ? "2px solid #2196f3"
                    : "1px solid transparent",
                borderLeft: `6px solid ${palette.primary.main}`,
                backgroundColor:
                  ativoSelecionado?.id === ativo.id ? "#e3f2fd" : "white",
                boxShadow:
                  ativoSelecionado?.id === ativo.id
                    ? "0 4px 12px rgba(25, 118, 210, 0.15)"
                    : "0 2px 4px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  backgroundColor:
                    ativoSelecionado?.id === ativo.id ? "#e3f2fd" : "#f5f5f5",
                  transform: "translateY(-1px)",
                  boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
                },
              }}
              disableRipple
              selected={ativoSelecionado?.id === ativo.id}
              onClick={() => handleExpandClick(ativo, index)}
            >
              <div className="d-flex flex-column gap-1">
                {renderAtivosContent(
                  ativo,
                  0,
                  Math.min(ativo.campos.length, 3),
                )}
                {ativo.campos.length > 3 && (
                  <Collapse
                    in={expandedCard.index === index && expandedCard.expanded}
                    timeout="auto"
                    unmountOnExit
                  >
                    <div className="d-flex flex-column gap-1">
                      {renderAtivosContent(ativo, 3, ativo.campos.length)}
                    </div>
                  </Collapse>
                )}
              </div>
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <Collapse in={expandedCard.expanded} timeout="auto" unmountOnExit>
        <DialogActions sx={{ pt: "0.5rem !important" }}>
          <Button
            color="primary"
            variant="contained"
            onClick={handleAdicionarAtivo}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10, color: "white" }}
            ></i>
            Confirmar
          </Button>
        </DialogActions>
      </Collapse>
    </Dialog>
  );
};

export default HistoricoAtivosDialog;
